module.exports = __webpack_public_path__ + "img/sugar_content_v.29b9f2f7.png";